/** PingPing 디자인 토큰 — theme.js·컴포넌트에서 공유 */
export const colors = {
  brand: {
    primary: '#0052FF', // Base-adjacent confident blue
    primaryDark: '#0041CC',
    primaryLight: '#4D84FF',
    accent: '#00D395', // trust / success accent
    accentDark: '#00A876',
  },
  neutral: {
    ink: '#0B0F19',
    inkMuted: '#5B6475',
    surface: '#F7F8FA',
    surfaceElevated: '#FFFFFF',
    border: '#E2E6EE',
  },
  semantic: {
    info: '#E8F0FF',
    infoBorder: '#B8D0FF',
    warning: '#FFF8E6',
    success: '#E6FBF3',
  },
};

export const typography = {
  fontFamily: {
    sans: '"Inter", "Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    mono: '"JetBrains Mono", ui-monospace, monospace',
  },
  weight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
};

export const radii = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  pill: 999,
};

export const spacing = {
  pageX: { xs: 2, sm: 3 },
  sectionY: { xs: 4, md: 6 },
};

export const shadows = {
  card: '0 1px 2px rgba(11, 15, 25, 0.06), 0 8px 24px rgba(11, 15, 25, 0.06)',
  hero: '0 4px 32px rgba(0, 82, 255, 0.08)',
};
